export const state = () => ({
  cache: {}, // { 'seo_homepage': {...}, 'seo_page_tentang-kami': {...} }
})

export const mutations = {
  SET_SEO_DATA(state, { key, data }) {
    state.cache[key] = data
  },
  CLEAR_CACHE(state) {
    state.cache = {}
  },
}

export const getters = {
  getSeoByKey: (state) => (key) => {
    return state.cache[key] || null
  },
}

export const actions = {
  async fetchSeo({ commit, getters }, { pageType, identifier, axios }) {
    const key = `seo_${pageType}_${identifier || 'homepage'}`

    // Check if already in cache
    if (getters.getSeoByKey && getters.getSeoByKey(key)) {
      return getters.getSeoByKey(key)
    }

    // Fetch from API if axios is provided
    if (axios) {
      try {
        const url = identifier ? `/api/seo/${pageType}/${identifier}` : `/api/seo/${pageType}`

        const response = await axios.get(url)

        if (response.data && response.data.data) {
          commit('SET_SEO_DATA', { key, data: response.data.data })
          return response.data.data
        }
      } catch (error) {
        if (process.env.NODE_ENV === 'development') {
          console.warn('Failed to fetch SEO data:', error.message || error)
        }
        return null
      }
    }

    return null
  },
}
